import styled from 'styled-components';
import UITable from 'UIComponents/table/UITable';
import { TABLE_TOP_BAR_HEIGHT, TABLE_PAGINATOR_HEIGHT, TABLE_NON_EMPTY_MIN_CONTENT_HEIGHT } from '../constants/sizes';
import { forwardRef } from 'react';
import { ScrollOverhang } from 'foundations-components/transitional/components/ScrollOverhang';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const ScrollWindow = styled.div.withConfig({
  displayName: "StyledTableComponents__ScrollWindow",
  componentId: "sc-17f1t0o-0"
})(["overflow:auto;max-width:100%;max-height:100%;"]);

// The ScrollOverhang component adds `flex: 1 1 auto` to its wrapper, which causes content overflow.
// This Flex container prevents that by using column layout with specific constraints (minInlineSize="0"
// and flexGrow={0}) to maintain proper scrolling behavior without expanding beyond its boundaries.
// See: https://git.hubteam.com/HubSpot/foundations-components/issues/3950
export const TableScrollContainer = /*#__PURE__*/forwardRef(({
  children
}, ref) => /*#__PURE__*/_jsx(Flex, {
  flexDirection: "column",
  inlineSize: "100%",
  blockSize: "100%",
  minInlineSize: "0",
  flexGrow: 0,
  children: /*#__PURE__*/_jsx(ScrollOverhang, {
    children: /*#__PURE__*/_jsx(ScrollWindow, {
      ref: ref,
      children: children
    })
  })
}));
export function TableBox(props) {
  const {
    loading,
    showPagination,
    showTopBar
  } = props;
  const maxBlockSize = `calc(100% ${showTopBar ? ` - ${TABLE_TOP_BAR_HEIGHT}` : ''} ${showPagination ? ` - ${TABLE_PAGINATOR_HEIGHT}` : ''})`;
  const minBlockSize = loading ? `${TABLE_NON_EMPTY_MIN_CONTENT_HEIGHT}px` : undefined;
  return /*#__PURE__*/_jsx(View, {
    borderColor: "border-core-default",
    borderStyle: "solid",
    borderWidth: "100",
    inlineSize: "100%",
    maxBlockSize: maxBlockSize,
    minBlockSize: minBlockSize,
    position: "relative",
    children: props.children
  });
}
export const StyledTable = styled(UITable).withConfig({
  displayName: "StyledTableComponents__StyledTable",
  componentId: "sc-17f1t0o-1"
})(["border-width:0;table-layout:fixed;thead{position:sticky;top:0;background-color:", ";z-index:4;th{border-top-width:0;}}tbody{td{height:", ";padding-bottom:", ";padding-top:", ";border:1px solid ", ";}td[data-frozen-column='true']{background-color:inherit;position:sticky;z-index:2;}tr{td:last-of-type{border-right-width:0;}td:first-of-type{border-left-width:0;}", "}tr:first-of-type{td{border-top-width:0;}}tr:last-of-type{td{border-bottom-width:0;}}}"], ({
  $theme
}) => $theme.color['fill-surface-default'], ({
  $theme
}) => $theme.space['1000'], ({
  $theme
}) => $theme.space['50'], ({
  $theme
}) => $theme.space['50'], ({
  $theme
}) => $theme.color['border-core-default'], ({
  $theme,
  zebraStripe = false
}) => {
  if (zebraStripe) {
    return `
            &:nth-child(even) {
              background-color: ${$theme.color['fill-field-default']};
            }
        `;
  }
});
export const StyledStickyBorderTable = styled(StyledTable).withConfig({
  displayName: "StyledTableComponents__StyledStickyBorderTable",
  componentId: "sc-17f1t0o-2"
})(["border-collapse:separate;border-spacing:0;tbody{td{border-color:", ";border-style:solid;border-width:calc(", " / 2);}}"], ({
  $theme
}) => $theme.color['border-core-default'], ({
  $theme
}) => $theme.borderWidth['100']);
export const NoFirstDivChildPadding = styled.div.withConfig({
  displayName: "StyledTableComponents__NoFirstDivChildPadding",
  componentId: "sc-17f1t0o-3"
})(["& > div:first-child{padding:0;}"]);